<template>

  <template v-if="this.$store.state.vModeWeek == 0">
    <template v-for="time in times" :key="time">
      <div class="time-column-vertical pill-h">
        <div>{{ time }}</div>
        <div> - </div>
        <div>{{ this.toTime(time) }}</div>
      </div>
    </template>
  </template>
  <template v-if="this.$store.state.vModeWeek == 1">
    <template v-for="time in times" :key="time">
      <div class="time-column-horizontal">
        <div>{{ time }}</div>
        <div> - </div>
        <div>{{this.toTime(time)}}</div>
      </div>
    </template>

  </template>
</template>
<style scoped>
.time-column-vertical{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: .7em;
  background: #eee;
  border-radius: 5px;
  margin-bottom: 1px;
}
.time-column-horizontal{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  line-height: .7em;
  background: #fff8da;
  border-radius: 5px;
  margin-bottom: 1px;
  container-name: time-column-horizontal-container;
  container-type: inline-size;
}
.time-column-horizontal{
  display: flex;
  flex-direction: column;
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  min-height: 3rem;
  line-height: .5em;
  margin-left: 1px;
}
.xsize-1 .time-column-horizontal{
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  min-height: 2.5rem;
  line-height: .45em;
}
.xsize-2 .time-column-horizontal{
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  min-height:3rem;
}
.xsize-3 .time-column-horizontal{
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  min-height:4rem;
  line-height: 0.7em;
}
@container time-column-horizontal-container (max-width: 1000px) {
  .time-column-horizontal div{
    font-size: 20cqw;
  }
}

@container booking-table-container (max-width: 1000px) {
  .time-column-vertical{
    height: 100cqw;
  }
}


@container left-column-container (max-width: 1000px) {
  .time-column-vertical {
    font-size: 0.7em;
    //height: 100cqw !important;
  }
}
</style>
<script>

export default {
  name: 'TimeLineMobile',
  emits: ['timeline-scroll'],
  props: {
    startTime: String,
    endTime: String
  },
  data() {
    return {
      times: [],
      // isLoading: true,
      minHour: 10,
      maxHour: 22,
      speed: 1, // Скорость скролла.
      left: 0, //нажали мышку - сохраняем положение скролла
      drag: false,
      coorX: 0, // нажали мышку - сохраняем координаты.
      startTimeLocal: "10:00",
      endTimeLocal: "22:00"
    }
  },

  updated() {

  },
  watch: {
    startTime: function () {
      this.startTimeLocal = this.startTime ? this.startTime : this.startTimeLocal
      this.endTimeLocal = this.endTime ? this.endTime : this.endTimeLocal
      this.buildData()
    },
  },

  created() {
    this.startTimeLocal = this.startTime ? this.startTime : this.startTimeLocal
    this.endTimeLocal = this.endTime ? this.endTime : this.endTimeLocal
    this.buildData()
  },
  mounted() {
    // this.$refs.mscroll.scrollLeft = 1
    // this.$refs.mscroll.scrollLeft = 0

  },
  computed: {},
  methods: {
    toTime(time) {
      let h = Number(time.split(':')[0]);
      let m = Number(time.split(':')[1]);
      let res = m > 0 ? h + 1 : h;
      res += ":";
      res += m > 0 ? "00" : "30";
      return res;
    },
    slider(slider, step, period) {
      const startTime = Date.now()
      const startLeft = slider.scrollLeft
      const render = () => {
        const dt = Date.now() - startTime
        if (dt < period) {
          slider.scrollLeft = startLeft + step * dt / period
          requestAnimationFrame(render)
        }
      }
      requestAnimationFrame(render)
    },

    itemScroll(child, left = true) {
      let item = child.closest('.mousescroll');
      let tracksW = item.scrollWidth;
      let elemW = item.clientWidth;
      tracksW = tracksW > elemW ? elemW * 2 : tracksW;
      let step = left ? tracksW / 2 : -tracksW / 2
      this.slider(item, step, 500)
    },
    sLeft({currentTarget}) {
      this.itemScroll(currentTarget, false)
    },
    sRight({currentTarget}) {
      this.itemScroll(currentTarget, true)
    },
    scrollHandler({currentTarget}) {

      let
          scrollLeft = Math.round(currentTarget.scrollLeft),
          scrollWidth = Math.round(currentTarget.scrollWidth),
          clientWidth = Math.round(currentTarget.clientWidth)

      if (scrollLeft < 5) {
        currentTarget.querySelector('.l-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.l-arrow').classList.add('show');
      }
      if (scrollWidth == Math.round(scrollLeft + clientWidth)) {
        currentTarget.querySelector('.r-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.r-arrow').classList.add('show');
      }
    },
    buildData() {

      let
          start = Number(this.startTimeLocal.split(':')[0]),
          startMinute = Number(this.startTimeLocal.split(':')[1]),
          end = Number(this.endTimeLocal.split(':')[0]),
          endMinute = Number(this.endTimeLocal.split(':')[1]),
          res = [];

      for (let $i = start; $i <= end; $i++) {
        if ($i == end && endMinute == 0) {
          break;
        }
        if (($i == start && startMinute == 0) || $i != start) {
          res.push($i + ':00')
        }
        if (($i == end - 1 && endMinute == 0) || $i != end) {
          res.push($i + ':30')
        }
      }

      this.times = res;
    },
    // buildData() {
    //   let
    //       start = Number(this.startTimeLocal.split(':')[0]),
    //       end = Number(this.endTimeLocal.split(':')[0]),
    //       res = [];
    //     for (let $i = start; $i < end; $i++) {
    //       res.push($i)
    //     }
    //   this.times = res;
    // },

    mousedown(e) {
      let el = e.currentTarget;
      this.drag = true
      this.coorX = e.pageX - el.offsetLeft;
      this.left = el.scrollLeft;

    },
    mouseup() {
      this.drag = false
    },
    mouseMove(e) {

      if (this.drag) {
        let el = e.currentTarget;
        let scroll = this.left - (e.pageX - el.offsetLeft - this.coorX) * this.speed;
        // console.log(e.pageX,el.offsetLeft)
        el.scrollLeft = scroll;
        // this.$emit('timeline-scroll',scroll)
      }

      // if (this.drag) {
      //   this.x = e.clientX;
      //   this.y = e.clientY;
      // }

      // console.log(event.clientX, event.clientY);
    }
  }
}
</script>
<script setup>
</script>